const { buildRoutes } = require('frontend-spa');
const docs = require('../../../pages/documentation/routes');

module.exports = buildRoutes([
  docs,
]);
